import type { ImageAsset, Testimonial } from '../types/content';
export const guideInteriorPages: ImageAsset[] = [];
export const templateSamples: ImageAsset[] = [];
export const packComposition: ImageAsset | null = null;

// Ervaringen van klanten, aangeleverd door de eigenaar. Afbeeldingen zijn AI-illustraties.
export const testimonials: Testimonial[] = [
  {
    id: 'marieke',
    name: 'Marieke',
    context: '47 jaar',
    quote:
      'Ik wilde de naam van mijn dochter maken om haar kamertje mee te versieren. Ik koos de kleuren en nam rustig de tijd om de letters te vormen. Sommige bochten moest ik een paar keer aanpassen, maar ik was zo blij toen de naam af was.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7349a9d7-5e56-4ade-8b0e-afaa964641d6.jpg',
    imageAlt: 'AI-illustratie: een naam in schrijfletters van lila en roze punnikkoord aan de muur van een pastelkleurige kinderkamer',
    imageIsIllustration: false,
  },
  {
    id: 'lotte',
    name: 'Lotte',
    context: '29 jaar',
    quote:
      'Ik zocht iets om thuis in mijn vrije tijd te doen, zonder steeds op mijn telefoon te zitten. Met punniken heb ik iets gevonden waar ik telkens weer zin in heb.',
    withImage: false,
  },
  {
    id: 'femke',
    name: 'Femke',
    context: '42 jaar',
    quote:
      'Ik begon met de handleiding voor sleutelhangers, omdat ik een kleinigheidje voor mijn vriendinnen wilde maken. Inmiddels verkoop ik de creaties die ik in mijn vrije tijd maak.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8d549af8-4b66-474f-9e73-86dbb2f6e8e2.jpg',
    imageAlt: 'AI-illustratie: sleutelhangers van pastelkleurig punnikkoord in de vorm van bloemen, hartjes en letters op kraftkaartjes',
    imageIsIllustration: true,
  },
  {
    id: 'anouk',
    name: 'Anouk',
    context: '56 jaar',
    quote:
      'Ik had al jaren niet meer geknutseld. Ik begon met een eenvoudige bloem en probeerde daarna andere sjablonen uit. Het was fijn om de handleiding bij de hand te hebben, zodat ik de stappen nog eens kon nalezen als ik vastliep.',
    withImage: false,
  },
  {
    id: 'eva',
    name: 'Eva',
    context: '38 jaar',
    quote:
      'Ik gebruikte de handleiding voor bedankjes om een paar cadeautjes voor een familiefeest te maken. Het kostte tijd, maar ik vond het ontzettend leuk om er een persoonlijk tintje aan te geven.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e9a070fa-60db-48f1-bb80-9cab0577db03.jpg',
    imageAlt: 'AI-illustratie: bedankjes in doosjes en organza zakjes, versierd met hartjes, sterren en bloemen van punnikkoord',
    imageIsIllustration: false,
  },
];

export function isTestimonialReady(t: Testimonial) {
  return t.quote.trim().length > 0;
}
